import ShipbobAppSettings from '../appSettings/appSetting'
import HttpWrapper from '../utils/http/httpWrapper'

const SHIPBOBV2_API = ShipbobAppSettings.shipbobV2Api
const PHOTOPRINT = ShipbobAppSettings.photoPrint
const USER_MAN = ShipbobAppSettings.userManApi
const USERACCOUNTS = ShipbobAppSettings.userAccountsApi

export default class UserService {
  static noop () {}

  static urls () {
    return {
      verifyRecaptcha: '/api/recaptcha',
      register: USERACCOUNTS + '/api/v1/Account/register',
      forgotPassword: PHOTOPRINT + '/Account/DoForgotPassword',
      login: PHOTOPRINT + '/Account/ValidateUser',
      saveToken: PHOTOPRINT + '/Account/SaveToken',
      saveRefreshedToken: PHOTOPRINT + '/Account/SaveRefreshedToken',
      logout: PHOTOPRINT + '/Account/LogOut',
      clearAuth: PHOTOPRINT + '/Account/ClearAuth',
      newPassword: PHOTOPRINT + '/Account/ForgotPassword',
      about: SHIPBOBV2_API + '/api/onboarding/qualifier1',
      getDetailedUser: USER_MAN + '/api/userData/fetchDetailedUserData',
      getLoggedInAndImpersonatedUser: USER_MAN + '/api/userData/fetchLoggedInAndImpersonatedBasicUserData',
      getImpersonatedDetailedUserData: USER_MAN + '/api/userData/fetchImpersonatedDetailedUserData',
      setUserStep: SHIPBOBV2_API + '/api/onboarding/savestep',
      markUserPrelaunch: SHIPBOBV2_API + '/api/onboarding/markUserPrelaunch',
      phone: SHIPBOBV2_API + '/api/onboarding/phone',
      business: SHIPBOBV2_API + '/api/onboarding/qualifier2',
      launchDate: SHIPBOBV2_API + '/api/onboarding/launchdate',
      pricingAssignmentExperiment: SHIPBOBV2_API + '/api/onboarding/pricingAssignmentExperiment',
      pricingPlan: PHOTOPRINT + '/QuickSetup/OnboardingUserPricingPlan',
      getQuickSetupSteps: PHOTOPRINT + '/QuickSetup/SvcGetSteps',
      upsertLandingPageEmail: SHIPBOBV2_API + '/api/onboarding/upsertLandingPageEmail',
      removeLandingPageEmail: SHIPBOBV2_API + '/api/onboarding/removeLandingPageEmail',
      getUserStores: PHOTOPRINT + '/QuickSetup/SvcGetUserStoreSettings',
      getMyProfileInfo: USERACCOUNTS + '/api/v1/userProfile/info',
      getOrgKYC: USERACCOUNTS + '/api/v1/CompanyProfile/kyc',
      reinitiateKycUrl: USERACCOUNTS + '/api/v1/CompanyProfile/reinitiateKyc'
    }
  }

  static async getKYCStatus () {
    const request = {
      Url: this.urls().getOrgKYC
    }

    return await HttpWrapper.Get(request, null, null, true)
  }

  static async reinitiateKyc () {
    const request = {
      Url: this.urls().reinitiateKycUrl,
      Data: {
        reason: 'Verification Link Expired'
      }
    }

    return await HttpWrapper.Post(request)
  }

  static async verifyRecaptcha (payload) {
    const request = {
      Url: this.urls().verifyRecaptcha,
      Data: {
        response: payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async register (payload) {
    const request = {
      Url: this.urls().register,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async forgotPassword (payload) {
    const request = {
      Url: this.urls().forgotPassword,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async newPassword (payload) {
    const request = {
      Url: this.urls().newPassword,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async login (payload) {
    const request = {
      Url: this.urls().login,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async saveToken (payload) {
    const request = {
      Url: this.urls().saveToken,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async saveRefreshedToken (payload) {
    const request = {
      Url: this.urls().saveRefreshedToken,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async logout (payload) {
    const request = {
      Url: this.urls().logout,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async clearAuth (payload) {
    const request = {
      Url: this.urls().clearAuth,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async about (payload) {
    const request = {
      Url: this.urls().about,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async getUser () {
    const request = {
      Url: this.urls().getUser
    }
    return await HttpWrapper.Get(request, null, null, true)
  }

  static async getDetailedUser () {
    const request = {
      Url: this.urls().getDetailedUser
    }
    return await HttpWrapper.Get(request, null, null, true)
  }

  static async getLoggedInAndImpersonatedUser () {
    const request = {
      Url: this.urls().getLoggedInAndImpersonatedUser
    }
    return await HttpWrapper.Get(request, null, null, true)
  }

  static async getImpersonatedDetailedUserData () {
    const request = {
      Url: this.urls().getImpersonatedDetailedUserData
    }
    return await HttpWrapper.Get(request, null, null, true)
  }

  static async phone (payload) {
    const request = {
      Url: this.urls().phone,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async setUserStep (step) {
    const request = {
      Url: this.urls().setUserStep,
      Data: {
        StepToSave: step
      }
    }
    return await HttpWrapper.Post(request, null, null, true)
  }

  static async markUserPrelaunch () {
    const request = {
      Url: this.urls().markUserPrelaunch,
      Data: {}
    }
    return await HttpWrapper.Post(request, null, null, true)
  }

  static async business (payload) {
    const request = {
      Url: this.urls().business,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async launchDate (payload) {
    const request = {
      Url: this.urls().launchDate,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async pricingAssignmentExperiment (payload) {
    const request = {
      Url: this.urls().pricingAssignmentExperiment,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async pricingPlan (payload) {
    const request = {
      Url: this.urls().pricingPlan,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request)
  }

  static async getQuickSetupSteps () {
    const request = {
      Url: this.urls().getQuickSetupSteps
    }
    return await HttpWrapper.Get(request, null, null, true)
  }

  static async getUserStores () {
    const request = {
      Url: this.urls().getUserStores
    }
    return await HttpWrapper.Get(request, null, null, true)
  }

  static async upsertLandingPageEmail (payload) {
    const request = {
      Url: this.urls().upsertLandingPageEmail,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request, null, null, true)
  }

  static async removeLandingPageEmail (payload) {
    const request = {
      Url: this.urls().removeLandingPageEmail,
      Data: {
        ...payload
      }
    }
    return await HttpWrapper.Post(request, null, null, true)
  }

  static async getMyProfileInfo () {
    const request = {
      Url: this.urls().getMyProfileInfo
    }

    return await HttpWrapper.Get(request, null, null, true)
      .then(response => ({ data: response, success: true }))
      .catch(error => ({ message: error, success: false }))
  }
}
